import { create } from "zustand";
import { persist } from "zustand/middleware";

interface DashboardFiltersState {
  selectedPlatforms: string[];
  setSelectedPlatforms: (platforms: string[]) => void;
  resetSelectedPlatforms: () => void;
}

export const useDashboardFiltersStore = create<DashboardFiltersState>()(
  persist(
    (set) => ({
      selectedPlatforms: [],
      setSelectedPlatforms: (platforms) =>
        set(() => ({
          selectedPlatforms: Array.from(
            new Set(
              (Array.isArray(platforms) ? platforms : [])
                .map((value) => String(value || "").trim())
                .filter(Boolean),
            ),
          ),
        })),
      resetSelectedPlatforms: () => set({ selectedPlatforms: [] }),
    }),
    { name: "dashboard-filters" },
  ),
);

